export const availableCategories = ['A', 'A1', 'B', 'B1', 'C', 'C1', 'D', 'D1', 'CE', 'C1E', 'DE', 'D1E', 'BE', 'BC1', 'Tm', 'Tb'];
